// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2Q53W","detailsBorder":"styles_detailsBorder__1NFPV"};